export const Marquee = ({ items = [], dark = false }) => {
  const row = (
    <>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-8 md:gap-12 shrink-0">
          <span className="font-display italic font-light text-3xl md:text-5xl whitespace-nowrap">{it}</span>
          <span className={`h-2.5 w-2.5 rounded-full shrink-0 ${dark ? "bg-brand-gold" : "bg-brand-red"}`} />
        </span>
      ))}
    </>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`edge-fade overflow-hidden py-8 border-y ${dark ? "bg-brand-choc text-brand-cream border-brand-cream/10" : "bg-brand-cream text-brand-ink border-brand-line"}`}
    >
      <div className="flex w-max animate-marquee gap-8 md:gap-12">
        <div className="flex items-center gap-8 md:gap-12">{row}</div>
        <div className="flex items-center gap-8 md:gap-12" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
};

export default Marquee;
